import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Row } from '../../types/Spreadsheet';
import { RootState } from '@store/store';

interface DeletedRowsState {
  deletedRows: Row[];
}

const initialState: DeletedRowsState = {
  deletedRows: []
};

const deletedRowsSlice = createSlice({
  name: 'deletedRows',
  initialState,
  reducers: {
    recordDeletedRows( state, action: PayloadAction<Row[]> ) {
      state.deletedRows.push( ...action.payload );
    },
    clearDeletedRows( state ) {
      state.deletedRows = [];
    }
  }
});

export const selectDeletedRows = ( state: RootState ) => state.spreadsheet.deletedRows.deletedRows;
export const { recordDeletedRows, clearDeletedRows } = deletedRowsSlice.actions;
export default deletedRowsSlice.reducer;